module.exports = "https://s3-us01.didiglobal.com/ibt-mobility-fe-static/driver-page/register/pop_99.b8b12028.png";